export default __webpack_public_path__ + "static/media/Group_final_25.bba658f5.jpg";